<template>
    <div class="pages clearfix">
        <div class="active-page">
            <div class="top-actions">
                <slot name="back" v-if="selectedPage.position == 'first'"></slot>
                <button class="btn btn-default" type="button" @click="previous()" v-if="selectedPage.position != 'first'">Previous</button>
                <button class="btn btn-default" type="button" @click="next()" v-if="selectedPage.position != 'last'">Next</button>
                <slot name="submit"></slot>
            </div>
            <slot></slot>
            <div class="bottom-actions">
                <slot name="back" v-if="selectedPage.position == 'first'"></slot>
                <button class="btn btn-default" type="button" @click="previous()" v-if="selectedPage.position != 'first'">Previous</button>
                <button class="btn btn-default" type="button" @click="next()" v-if="selectedPage.position != 'last'">Next</button>
                <slot name="submit"></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            selectedPage: false,
            selectedIndex: 0
        }
    },
    computed: {
        pages() {
            return this.$children
        }
    },
    mounted() {
        if (window.location.hash) {
            let page = {
                name: window.location.hash.replace(/#/, '')
            }
            this.selectPage(page);
        } else {
            this.selectCurrentIndex();
        }
    },
    methods: {
        selectPage(selectedPage) {
            this.pages.forEach((page,i) => {
                page.isActive = (page.name == selectedPage.name)
                if (page.isActive) {
                    this.selectedPage = page;
                    window.location.hash = `#${page.name}`
                    this.selectedIndex = i
                }
            })
        },
        selectCurrentIndex() {
            this.selectPage(this.$children[this.selectedIndex])
        },
        next() {
            if (this.selectedIndex < this.$children.length - 1) {
                this.selectedIndex++
            }
            
            this.selectCurrentIndex();
        },
        previous() {
            if (this.selectedIndex > 0) {
                this.selectedIndex--;
            }
            
            this.selectCurrentIndex();
        },
    }
}
</script>